import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
@Component({
  selector: 'app-selected-lucky-numbers-locked',
  templateUrl: './selected-lucky-numbers-locked.component.html',
  styleUrls: ['./selected-lucky-numbers-locked.component.scss'],
})
export class SelectedLuckyNumbersLockedComponent implements OnInit {
  languageCode: string = "en";
  goodLuckPopupTranslatedData: any;
  closeButton: string;
  description: string;
  title: string;

  constructor(
    private matDialog: MatDialog,
    private matDialogRef: MatDialogRef<SelectedLuckyNumbersLockedComponent>,
    private jackpotTriggerService: JackpotTriggersService,
    private authService: AuthService,
  ) {
    this.matDialogRef.disableClose = true;
  }

  ngOnInit() {
    this.authService?.userDetails$?.subscribe((user: any) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
      this.jackpotTriggerService?.getTranslatedData(this.languageCode)?.subscribe(
        (data) => {
          this.goodLuckPopupTranslatedData = data?.["lucky_numbers_good_luck_popup"];
          this.closeButton = this.goodLuckPopupTranslatedData?.close_button;
          this.description = this.goodLuckPopupTranslatedData?.description;
          this.title = this.goodLuckPopupTranslatedData?.title;
        },
        (err) => {
          return err;
        }
      );
    });
  }

  closePopup() {
    this.matDialog.closeAll();
  }
}
